import { render, staticRenderFns } from "./MoleculePaginatePrimary.vue?vue&type=template&id=6fbe3a5a&"
import script from "./MoleculePaginatePrimary.vue?vue&type=script&lang=js&"
export * from "./MoleculePaginatePrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports